import React, { useRef, useState, useEffect } from "react";
import { useParams, useHistory, useLocation } from "react-router-dom";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import numberFormatter from 'number-formatter'
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge, Table } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Form } from "react-bootstrap/";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import Linkify from 'react-linkify';
import ReactHtmlParser from 'react-html-parser'; 
import QrScanner from 'components/QrScanner';


import LoaderButton from "./LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

// import "../../node_modules/noty/lib/noty.css";
// import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
// import "./Show.css";

export default function GiftStats({show, ...props}) {
    
  //const file = useRef(null);
  const { id } = useParams();
  const history = useHistory();

  const [stats, setStats] = useState(null);  
  const [isLoading, setIsLoading] = useState(false);  


    useEffect(() => {
        async function onLoad() {
            try {           
                setIsLoading(true)

                loadStats()    

            } catch (e) {
                onError(e);
            } finally {
                setIsLoading(false)
            }
        }

        onLoad();
    }, [show]);
    

    async function loadStats() {
        try {
            setIsLoading(true)

            const stats = await API.get("vivelo", `/etickets/gifts?s=${show._id}`);
            setStats(stats)
            
            return stats
        } finally {
            setIsLoading(false)
        }
    }    
    
    function renderTable() {
        console.log(stats)
        return <Table responsive striped bordered hover variant="dark">
            <tr>
                <th>Regalos</th>
            </tr>
            <tr>
                <td>{stats.total || 0}</td>
            </tr>
        </Table>
    }



    function renderStats() {        

        return <>
        <div className="container show-tickets">
                <LoaderButton onClick={loadStats} isLoading={isLoading} >Actualizar</LoaderButton>
                <br /><br />
                <>{stats && renderTable()}</>        
        </div> 
        </>
    }
    
    return (        
        show ? <>
        <div>
            {renderStats()}
        </div>
        </> : null
  );
}